"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class CompanyOnboarding {
    static getStatus(token) {
        let url = `/companyonboarding`;
        return Client_1.default.httpGet(url, token);
    }
    static listUploads(token, prefix) {
        let url = `/companyonboarding/upload/list?prefix=${prefix}`;
        return Client_1.default.httpGet(url, token);
    }
    static startUpload(token, prefix, type, filename) {
        let url = `/companyonboarding/upload/start?prefix=${prefix}&type=${type}&filename=${filename}`;
        return Client_1.default.httpGet(url, token).then((d) => d.url);
    }
    static getEmployeeOnboardingStatus(token) {
        let url = `/companyonboarding/employeeonboarding`;
        return Client_1.default.httpGet(url, token);
    }
    static getPayrollFunding(token) {
        let url = `/companyonboarding/getPayrollFunding`;
        return Client_1.default.httpGet(url, token);
    }
    static submitPayrollFunding(token, body) {
        let url = "/companyonboarding/submitPayrollFunding";
        return Client_1.default.httpPost(url, token, body);
    }
    static getClientDetailsToVerify(token) {
        let url = `/companyonboarding/getClientDetailsToVerify`;
        return Client_1.default.httpGet(url, token);
    }
    static verifyClientDetails(token, body) {
        let url = "/companyonboarding/verifyClientDetails";
        return Client_1.default.httpPost(url, token, body);
    }
}
exports.default = CompanyOnboarding;
